// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --color-bg-primary: #0a0a0a;
    --color-bg-secondary: #0d0d0d;
    --color-bg-nav: #111111;
    --color-green: #00ff88;
    --color-green-dim: #00ff8899;
    --color-green-muted: #00ff8877;
    --color-green-faint: #00ff8866;
    --color-green-trace: #00ff8844;
    --color-cyan: #00ccff;
    --color-cyan-dim: #00ccff99;
    --color-cyan-ghost: #00ccff88;
    --color-border: #00ff8822;
    --color-cyan-rank-bg: #00ccff11;

    font-size: 62.5%;
}

body {

    margin: 0px;
    padding: 0px;
    font-size: 1.6rem;
    background-color: var(--color-bg-primary);
    color: var(--color-green-dim);
}

header {
    display: flex;
    background-color: var(--color-bg-nav);
    justify-content: space-between;
    padding: 2rem 4rem;
    align-items: center;
}

header>.name {
    font-size: 3rem;
}

.name {
    display: flex;
}

.name>div:first-child {
    color: var(--color-green);
}

.name>div:last-child {
    color: var(--color-cyan);
}

nav {
    display: flex;
    gap: 4rem;
}

nav>button {
    color: var(--color-green-dim);
    border: none;
    background-color: var(--color-bg-nav);
}

nav>button:hover {
    color: var(--color-green);
}

footer {
    margin-top: 1rem;
    border-top: 1px solid var(--color-border);
    display: flex;
    background-color: var(--color-bg-nav);
    justify-content: space-between;
    padding: 2rem 4rem;
    align-items: center;
    color: var(--color-green-trace);
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,qBAAqB;IACrB,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,+BAA+B;;IAE/B,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC","sourcesContent":[":root {\n    --color-bg-primary: #0a0a0a;\n    --color-bg-secondary: #0d0d0d;\n    --color-bg-nav: #111111;\n    --color-green: #00ff88;\n    --color-green-dim: #00ff8899;\n    --color-green-muted: #00ff8877;\n    --color-green-faint: #00ff8866;\n    --color-green-trace: #00ff8844;\n    --color-cyan: #00ccff;\n    --color-cyan-dim: #00ccff99;\n    --color-cyan-ghost: #00ccff88;\n    --color-border: #00ff8822;\n    --color-cyan-rank-bg: #00ccff11;\n\n    font-size: 62.5%;\n}\n\nbody {\n\n    margin: 0px;\n    padding: 0px;\n    font-size: 1.6rem;\n    background-color: var(--color-bg-primary);\n    color: var(--color-green-dim);\n}\n\nheader {\n    display: flex;\n    background-color: var(--color-bg-nav);\n    justify-content: space-between;\n    padding: 2rem 4rem;\n    align-items: center;\n}\n\nheader>.name {\n    font-size: 3rem;\n}\n\n.name {\n    display: flex;\n}\n\n.name>div:first-child {\n    color: var(--color-green);\n}\n\n.name>div:last-child {\n    color: var(--color-cyan);\n}\n\nnav {\n    display: flex;\n    gap: 4rem;\n}\n\nnav>button {\n    color: var(--color-green-dim);\n    border: none;\n    background-color: var(--color-bg-nav);\n}\n\nnav>button:hover {\n    color: var(--color-green);\n}\n\nfooter {\n    margin-top: 1rem;\n    border-top: 1px solid var(--color-border);\n    display: flex;\n    background-color: var(--color-bg-nav);\n    justify-content: space-between;\n    padding: 2rem 4rem;\n    align-items: center;\n    color: var(--color-green-trace);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
